var defaultGroups = {

}

export const alias = {
    'cs': {
        'all-product' : 'vsechny-produkty',
        'food-supplements': 'doplnky-stravy',
        'colostrum-products': 'colostrum-produkty',
        'functional-chocoloate': 'funkcni-cokolady',
        'baby-nutrition': 'detska-vyziva',
        'pet-food-supplements': 'zvireci-doplnky-stravy',
        'cosmetics': 'kosmetika',
        'multicomponent-excipients': 'multikomponentni-excipienty',

        'anti-aging': 'anti-aging',
        'joint-body': 'joint-body',
        'digestive-detox': 'digestive-detox',
        'immunity': 'imunita',
        'weight-management': 'kontrola-vahy',
        'diabetes-prevention': 'prevence-diabetu',
        'sleep-and-mood': 'mocove-cesty',
        'mens-health': 'muzske-zdravi',
        'sports-nutrition-energy': 'sports-nutrition-energy',
        'children': 'deti',
        'cardio': 'kardio',

        'colostrum': 'colostrum',
        'collagen': 'collagen',
        'polyphenols': 'polyphenols',

        'capsules-tablets': 'kapsle-tablety',
        'chocolates': 'cokolady',
        'powders': 'prasky',
        'instant-drinks': 'instantni-napoje',
    }
}

// zde
// 'infant-milk-powder-1',
// 'follow-on-milk-powder-2',
// 'follow-on-milk-powder-3',
// 'growing-up-milk-powder-4',

// 'baby-nutrition':[
//     'infant-milk-powder-1',
//     'follow-on-milk-powder-2',
//     'follow-on-milk-powder-3',
//     'growing-up-milk-powder-4',
// ],

// 'infant-milk-powder-1',
// 'follow-on-milk-powder-2',
// 'follow-on-milk-powder-3',
// 'growing-up-milk-powder-4',

const customGroups = {
    'all-products':[
        'beauty-therapy-drink',
        'collagen-flexi-drink',
        'neo-curcumin-supplements',
        'neo-gluco-supplements',
        'neo-sleep-supplements',
        'orally-dispersible-tablets',
        'pretty-woman-selenium-forte',
        'pretty-woman-collagen-selenium',
        'probiotics-forte',
        'immuno-forte',
        'uro-cranberries-prevention',
        'youth-elixir-resveratrol',
        'immuno-vitamin-d',
        'beauty-skin-astaxanthin',
        'power-man-selenium-forte',
        'colostrum',
        'colostrum-stick',
        'sticks',
        'colostrum-capsules',
        'immuno-colostrum-powder',
        'immuno-colostrum-bio-aronia',
        'chocolate-goat-milk',
        'chocolate-immuno',
        'chocolate-cannabis-seeds',
        'chocolate-slim',
        'chocolate-nutrition-protein',
        'chocolate-matcha-tea',
        'chocolate-happy-kids',
        'chocolate-natural-energizer',
        'chocolate-energy-guarana',
        'chocolate-vitality',
        'chocolate-healthy-body',
        'chocolate-relax',

        'cosmetics-day-cream',
        'cosmetics-night-cream',
        'cosmetics-serum',
        'cosmetics-panthenol',
        'multicomponent-excipients-mceodt',
        'multicomponent-excipients-mcemr',
    ],

    'food-supplements':[
        'beauty-therapy-drink',
        'collagen-flexi-drink',
        'neo-curcumin-supplements',
        'neo-gluco-supplements',
        'neo-sleep-supplements',
        'orally-dispersible-tablets',
        'sticks',
        'colostrum-stick',
        'pretty-woman-selenium-forte',
        'pretty-woman-collagen-selenium',
        'probiotics-forte',
        'immuno-forte',
        'uro-cranberries-prevention',
        'youth-elixir-resveratrol',
        'immuno-vitamin-d',
        'beauty-skin-astaxanthin',
        'power-man-selenium-forte',
    ],
    'colostrum-products':[
        'colostrum',
        'colostrum-capsules',
        'colostrum-stick',
        'immuno-colostrum-powder',
        'immuno-colostrum-bio-aronia',
        'immuno-forte',
        'chocolate-immuno',
        'cosmetics-day-cream',
        'cosmetics-night-cream',
        'cosmetics-serum',
        'cosmetics-panthenol',
    ],
    'functional-chocoloate':[
        'chocolate-goat-milk',
        'chocolate-immuno',
        'chocolate-cannabis-seeds',
        'chocolate-slim',
        'chocolate-nutrition-protein',
        'chocolate-matcha-tea',
        'chocolate-happy-kids',
        'chocolate-natural-energizer',
        'chocolate-energy-guarana',
        'chocolate-vitality',
        'chocolate-healthy-body',
        'chocolate-relax',
    ],

    'pet-food-supplements':[

    ],
    'cosmetics':[
        'cosmetics-day-cream',
        'cosmetics-night-cream',
        'cosmetics-serum',
        'cosmetics-panthenol',
    ],
    'multicomponent-excipients':[
        'multicomponent-excipients-mceodt',
        'multicomponent-excipients-mcemr',
    ],


    'anti-aging': [
        'neo-curcumin-supplements',
        'pretty-woman-selenium-forte',
        'pretty-woman-collagen-selenium',
        'cosmetics-panthenol',
        'beauty-therapy-drink',
    ],
    'joint-body': [
        'collagen-flexi-drink',
        'neo-curcumin-supplements',
    ],
    'digestive-detox': [
        'neo-curcumin-supplements',
        'probiotics-forte',
        'chocolate-goat-milk',
    ],
    'immunity': [
        'neo-curcumin-supplements',
        'probiotics-forte',
        'immuno-forte',
        'colostrum-stick',
        'colostrum-capsules',
        'immuno-colostrum-powder',
        'immuno-colostrum-bio-aronia',
        'chocolate-immuno',
        'chocolate-cannabis-seeds',
    ],
    'weight-management': [
        'chocolate-goat-milk',
        'chocolate-immuno',
        'chocolate-cannabis-seeds',
        'chocolate-slim',
        'chocolate-nutrition-protein',
        'chocolate-matcha-tea',
        'chocolate-happy-kids',
        'chocolate-natural-energizer',
        'chocolate-energy-guarana',
        'chocolate-vitality',
        'chocolate-healthy-body',
        'chocolate-relax',
    ],
    'diabetes-prevention': [
        'neo-curcumin-supplements',
        'neo-gluco-supplements',
    ],
    'sleep-and-mood': [
        'neo-curcumin-supplements',
        'neo-sleeo-supplements', 
        'uro-cranberries-prevention',
    ],
    'mens-health': [
        'power-man-selenium-forte',
    ],
    'sports-nutrition-energy': [
        'collagen-flexi-drink',
        'chocolate-goat-milk',
        'chocolate-immuno',
        'chocolate-cannabis-seeds',
        'chocolate-slim',
        'chocolate-nutrition-protein',
        'chocolate-matcha-tea',
        'chocolate-happy-kids',
        'chocolate-natural-energizer',
        'chocolate-energy-guarana',
        'chocolate-vitality',
        'chocolate-healthy-body',
        'chocolate-relax',
    ],
    'children': [
        'colostrum-capsules',
        'immuno-colostrum-powder',
        'immuno-colostrum-bio-aronia',
        'chocolate-happy-kids',
        'colostrum-stick',

    ],
    'cardio': [
        'neo-curcumin-supplements',
        'neo-gluco-supplements',
    ],



    'colostrum': [
        'colostrum',
        'colostrum-capsules',
        'immuno-colostrum-powder',
        'immuno-colostrum-bio-aronia',
        'immuno-forte',
        'chocolate-immuno',
        'cosmetics-day-cream',
        'cosmetics-night-cream',
        'cosmetics-serum',
        'cosmetics-panthenol',
        'cosmetics-stick',
    ],
    'collagen': [
        'beauty-therapy-drink',
        'collagen-flexi-drink',
        'pretty-woman-collagen-selenium',
        'cosmetics-day-cream',
        'cosmetics-night-cream',
        'cosmetics-serum',
    ],
    'polyphenols': [
        'neo-gluco-supplements',
        'uro-cranberries-prevention',
        'youth-elixir-resveratrol',
    ],



    'capsules-tablets': [
        'neo-curcumin-supplements',
        'neo-gluco-supplements',
        'colostrum-capsules',
    ],
    'chocolates': [
        'pretty-woman-selenium-forte',
        'pretty-woman-collagen-selenium',
        'probiotics-forte',
        'immuno-forte',
        'uro-cranberries-prevention',
        'youth-elixir-resveratrol',
        'immuno-vitamin-d',
        'beauty-skin-astaxanthin',
        'power-man-selenium-forte',
        'chocolate-goat-milk',
        'chocolate-immuno',
        'chocolate-cannabis-seeds',
        'chocolate-slim',
        'chocolate-nutrition-protein',
        'chocolate-matcha-tea',
        'chocolate-happy-kids',
        'chocolate-natural-energizer',
        'chocolate-energy-guarana',
        'chocolate-vitality',
        'chocolate-healthy-body',
        'chocolate-relax',
    ],
    'powders': [
        'beauty-therapy-drink',
        'collagen-flexi-drink',
        'colostrum',
        'immuno-colostrum-powder',
        'immuno-colostrum-bio-aronia',
        'multicomponent-excipients-mceodt',
        'multicomponent-excipients-mcemr',
        'colostrum-stick', 
    ],
    'instant-drinks': [
        'beauty-therapy-drink',
        'collagen-flexi-drink',
    ]
}

// 'infant-milk-powder-1',
// 'follow-on-milk-powder-2',
// 'follow-on-milk-powder-3',
// 'growing-up-milk-powder-4',
// ],
var groups = Object.assign(defaultGroups, customGroups)

export default groups



// WEBPACK FOOTER //
// ./data/catalogGroups.js